<template>
  <div id="app" class="flex items-center justify-center h-full w-full">
    <div>
      <h1 id="logo">LeBraun</h1>
      <div id="under-maintenance">
        Under maintenance
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html,
body {
 @apply h-full w-full bg-gray-100;
}

#app {
  font-family: 'Avenir Next', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#logo {
  @apply font-hairline mb-2 uppercase;
  font-size: 24px;
  letter-spacing: 5px;
}

#under-maintenance {
  @apply font-medium italic text-gray-400 uppercase;
  font-size: 10px;
  letter-spacing: 1.5px;
}
</style>
